export default __webpack_public_path__ + "static/media/qrcode.040dbf4f.png";